/**
 * ChatChannelData 类型和 Schema 定义
 *
 * ⚠️ 注意: 此文件由脚本自动生成，请勿手动修改
 * 如需更新，请运行代码生成脚本
 */
import type { SchemaDefinition } from './_schema'
import type { ChatChannel } from './chat_channel'
import type { UserData } from './user_data'

/**
 * ChatChannelData
 */
export interface ChatChannelData {
  /** 频道ID */
  id?: string
  /** 频道基础信息 */
  info?: ChatChannel
  /** 创建者信息 */
  creator?: UserData
  /** 成员信息（私聊场景） */
  members?: UserData[]
}

/**
 * ChatChannelData Schema
 */
export const ChatChannelDataSchema: SchemaDefinition = {
  properties: {
    id: {
      description: '频道ID',
      format: 'string',
      type: 'string',
      label: '频道ID',
    },
    info: {
      $ref: 'ChatChannel',
      description: '频道基础信息',
      label: '频道基础信息',
    },
    creator: {
      $ref: 'UserData',
      description: '创建者信息',
      label: '创建者信息',
    },
    members: {
      description: '成员信息（私聊场景）',
      format: '[]*model.UserData',
      items: { $ref: 'UserData', description: '' },
      type: 'array',
      label: '成员信息',
    },
  },
  type: 'object',
}
